const ALLOWED = {
  A: ["href", "target", "rel", "title"],
  IMG: ["src", "alt", "title", "style", "width", "height"],
  BR: [],
  SPAN: ["style"],
  DIV: ["style"],
  P: ["style"],
  STRONG: [],
  EM: [],
  B: [],
  I: [],
};

function sizeHasHtml(value) {
  return /<\/?[a-z][^>]*>/i.test(String(value || ""));
}

function safeUrl(value) {
  const url = String(value || "").trim();
  if (!url || /^\s*javascript:/i.test(url)) return "";
  return url;
}

function safeStyle(value) {
  return String(value || "")
    .replace(/expression\s*\(/gi, "")
    .replace(/javascript\s*:/gi, "")
    .replace(/@import/gi, "");
}

function sanitizeSizeHtml(value) {
  if (typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(String(value || ""), "text/html");
  const clean = (node) => {
    let child = node.firstChild;
    while (child) {
      const next = child.nextSibling;
      if (child.nodeType === 1) {
        const tag = child.tagName;
        if (!ALLOWED[tag]) {
          while (child.firstChild) node.insertBefore(child.firstChild, child);
          node.removeChild(child);
          child = node.firstChild;
          continue;
        }
        [...child.attributes].forEach((attr) => {
          const name = attr.name.toLowerCase();
          if (!ALLOWED[tag].includes(name)) {
            child.removeAttribute(attr.name);
            return;
          }
          if (name === "href" || name === "src") {
            const url = safeUrl(attr.value);
            if (!url) child.removeAttribute(attr.name);
            else child.setAttribute(name, url);
          }
          if (name === "style") child.setAttribute("style", safeStyle(attr.value));
        });
        if (tag === "A") {
          child.setAttribute("target", "_blank");
          child.setAttribute("rel", "noopener noreferrer");
        }
        clean(child);
      }
      child = next;
    }
  };
  clean(doc.body);
  return doc.body.innerHTML;
}

module.exports = {
  sizeHasHtml,
  sanitizeSizeHtml,
};
